import React, { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { FiAward, FiCopy, FiInfo, FiLink, FiUsers } from "react-icons/fi";
import { getReferral, getRedeemRequestHistoryData } from "./MyReferral.api";
import { useAuth } from "context/auth-context";
import NavCard from "components/Dashboard/NavCard";
import { useTranslation } from "react-i18next";
import LoadingOverlay from "react-loading-overlay-ts";
import { ReferralUserTable } from "./ReferralUserTable";
import { PageHeader, StatCard } from "components/ui";

export const MyReferral = () => {
  const { auth } = useAuth();
  const host = window.location.protocol + "//" + window.location.host;
  const divRef = React.useRef<HTMLInputElement | null>(null);
  const { t } = useTranslation();
  const [referralCount, setReferralCount] = useState(0);
  const [currentPage] = useState<number>(1);
  const getReferralData = useQuery(["referral"], () => getReferral(auth.panelistId, currentPage), {
    refetchOnWindowFocus: false,
  });

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  function copyFunction(e: any) {
    if (referralCount < 10) {
      if (window.navigator.clipboard) {
        const copyText = divRef.current;
        navigator.clipboard.writeText(copyText.value).then(() => {
          alert(`Copied the text : ${host}/join-now?referralBy=` + auth.email);
        });
      }
    } else {
      alert(t("referFriend.Maximum.limit.reached"));
    }
  }
  const getReferralvirtualwallet = useQuery(
    ["virtual"],
    () => getRedeemRequestHistoryData(auth.panelistId, currentPage),
    {
      refetchOnWindowFocus: false,
    }
  );

  useEffect(() => {
    getReferralData.refetch();
  }, [currentPage]);

  useEffect(() => {
    getReferralvirtualwallet.refetch();
  }, [currentPage]);

  return (
    <>
      <LoadingOverlay
        styles={{
          overlay: (base) => ({
            ...base,
            position: "fixed",
            background: "rgb(var(--zs-overlay) / 0.45)",
          }),
        }}
        active={getReferralData.isLoading}
        spinner
        text={t("claim.card.Loading")}
      >
        <div className="zs-page">
          <PageHeader
            eyebrow="Referrals"
            title={t("side.bar.Friend")}
            subtitle={t("referFriend.Spread the word and earn rewards")}
          />

          <div className="mb-6">
            <NavCard />
          </div>

          <div className="grid grid-cols-1 gap-4 lg:grid-cols-3">
            {/*Referral link box */}
            <section className="p-5 zs-card sm:p-6 lg:col-span-2">
              <div className="flex items-start gap-3">
                <span className="inline-flex items-center justify-center w-10 h-10 rounded-lg shrink-0 bg-primary-soft text-primary-text">
                  <FiLink className="w-5 h-5" aria-hidden="true" />
                </span>
                <div className="min-w-0">
                  <h2 className="zs-section-title">{t("referFriend.Referral Link")}</h2>
                  <p className="mt-1 text-sm text-ink-3">
                    {t("referFriend.Get")}{" "}
                    <span className="font-semibold text-ink">
                      30 {t("referFriend.Points")}{" "}
                      {t("referFriend.for every friend you refer to Zamplia Surveys")}
                    </span>
                  </p>
                </div>
              </div>

              <div className="flex flex-col gap-2 mt-5 sm:flex-row">
                <input
                  data-testid="copyFun"
                  type="text"
                  id="myInput"
                  ref={divRef}
                  name="myInput"
                  readOnly
                  aria-label={t("referFriend.Referral Link")}
                  value={`${host}/join-now?referralBy=` + auth.email}
                  className="flex-1 min-w-0 font-mono text-[13px] zs-input bg-surface-2 text-ink-2"
                />
                <button className="zs-btn zs-btn-primary shrink-0" onClick={(e: any) => copyFunction(e)}>
                  <FiCopy aria-hidden="true" />
                  {t("referFriend.copy")}
                </button>
              </div>

              <ul className="flex flex-col gap-2 mt-5">
                {[t("referFriend.Share your unique referral"), t("referFriend.Maximum.limit")].map((note, index) => (
                  <li key={index} className="flex items-start gap-2.5 px-3 py-2.5 text-sm rounded border border-line bg-surface-2 text-ink-2">
                    <FiInfo className="w-4 h-4 mt-0.5 shrink-0 text-info" aria-hidden="true" />
                    <p>{note}</p>
                  </li>
                ))}
              </ul>
            </section>

            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-1">
              <StatCard
                label={t("referFriend.My Referral Users")}
                value={referralCount}
                icon={<FiUsers />}
                meta={t("referFriend.Maximum.limit")}
                loading={getReferralData.isLoading}
              />
              <StatCard
                label="Reward per referral"
                value={30}
                icon={<FiAward />}
                tone="success"
                meta={t("referFriend.Points")}
              />
            </div>
          </div>

          <div className="mt-4">
            <ReferralUserTable setReferralCount={setReferralCount} />
          </div>
        </div>
      </LoadingOverlay>
    </>
  );
};
